export enum Label {
  TeamMeeting = 1,
  SoloWork = 2,
}
